import { z } from 'zod';
export const employeeBucketSchema = z.enum(['1-5', '6-20', '21-50', '51-200', '201+']);
export const companyDataStepSchema = z.object({
    name: z.string().trim().min(1),
    street: z.string().trim().min(1),
    nr: z.string().trim().min(1),
    city: z.string().trim().min(1),
    postcode: z.string().trim().min(1),
    website: z.string().trim().min(1).optional(),
    employees: employeeBucketSchema,
});
